import { MarkerTool } from "@/utils/ash/ash-icon-marker"

export const get_common_create_layer_options = ({ id, pane_text, pane_order, product_sub_type, information }) => {
    return {
        name: id, // 必須唯一，才不會放錯 pane
        text: pane_text,
        pane_order: pane_order,
        sub_type: product_sub_type,
        information: information,
    }
}

export const get_file_path = (product, data_file_index = -1) => {
    return data_file_index >= 0 ? product['files'][data_file_index]['file_path'] : undefined
}

export const calculate_pane_opacity = (selected_products) => {
    const is_includes_gis_type = selected_products.some(({ product_type }) => product_type === 'gis')
    return is_includes_gis_type ? 0.3 : 1
}

export const create_bind_marker_data_by_config = (product, properties, configs) => {
    const { product_type, product_sub_type } = product
    const config = configs[product_type][product_sub_type]

    if(!config) return ''
    return config.reduce((accumulator, {name, column, unit}) => {
        let value = '---';
        if (column.length === 2) {
            value = `${properties[column[0]] || '---'}(${properties[column[1]] || '---'})`;
        } else if (column.length === 1) {
            value = properties[column[0]];
        }

        value = unit ? `${value} ${unit}` : value
        return {...accumulator, ...{
            [name]: value
        }}
    }, '')
}

export const create_alert_content_structure = (feature, id) => {
    return feature.properties?.table_content
}

export const get_icon_marker_options = (feature) => {
    return MarkerTool.create(
        {
            type: feature['marker-type'] || 'icon_circle_marker',
            icon_type: feature['marker-icon-type'] || 'material', //fa, material  TODO 改成帶 icon 這個分類
            icon_name: feature['marker-icon'], //default: star
            background_color: feature['marker-color'], //default: #ff6464(pink)
            color: feature['marker-font-color'],
            marker_size: feature['marker-size'], //medium
            marker_opacity: feature['marker-opacity'],
            border: (feature['marker-border'] === false) ? false : 'white', //default: white, black/false
            shadow: (feature['marker-border'] === false) ? false : true, //default: true
            class_name: feature['class_name'] || '',
            marker_text: feature['marker-text'] || '',
            text_color: feature['text-color'] || ''
        }
    )
}